import { TFunction } from "i18next";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { formatNumber } from "src/utility";

const INITIAL_GIFTS_SEARCH = {
  name: "",
  categoryCode: "",
};

const rangeLabel = (min: number, max: number, suffix: string) =>
  min === max ? `${formatNumber(min)}${suffix}` : `${formatNumber(min)}-${formatNumber(max)}${suffix}`;

const aggregatedData = {
  points: {
    labelTransform: (items: DiscountItemType[], t: TFunction) => {
      const vals = items
        .flatMap((i) => {
          return i?.denominationType === "Range"? [(Number(i?.from) ?? 0) * (i?.pointsFactor ??0), (Number(i?.to) ?? 0) * (i?.pointsFactor ??0)]: (i?.points ?? 0);
        })
        .filter((v) => isFinite(v));
      
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return (
        <div>
          <span className="font-inter text-base font-semibold">{min === max ? formatNumber(min) : `${formatNumber(min)}-${formatNumber(max)}`}</span>
          <span className="text-xs font-normal">{t("Giftcards.pointsSuffix")}</span>
        </div>
      );
    },
  },
  totalPrice: {
    labelTransform: (items: DiscountItemType[]) => {
      const vals = items.map((i) => i.totalPrice);
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return <span>{rangeLabel(min, max, "")}</span>;
    },
  },
  validityInDays: {
    labelTransform: (items: DiscountItemType[], t: TFunction) => {
      const vals = items.map((i) => i.validityInDays).filter((v): v is number => v != null);
      if (vals.length === 0) return <span>{t("Giftcards.noExpiry")}</span>;
      const min = Math.min(...vals);
      const max = Math.max(...vals);
      return <span>{rangeLabel(min, max, t("Giftcards.daysSuffix"))}</span>;
    },
  },
};

export { INITIAL_GIFTS_SEARCH, rangeLabel,aggregatedData };
